module.exports = __webpack_public_path__ + "img/_3.23342e6d.png";